import SuratJalanSupplyForSubcontractDetail from '@/models/SuratJalanSupplyForSubcontract/SuratJalanSupplyForSubcontractDetail';

export default class SuratJalanSupplyForSubcontractDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.suratJalanSupplyForSubcontractId  = '';
		this.suratJalanSupplyForSubcontractSuratJalanNo = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.orderQty = '';
		this.deliveryQty = '';
		this.workOrderSupplySubcontractDetailId  = '';
		this.workOrderSupplySubcontractDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			suratJalanSupplyForSubcontractId : '0',
			suratJalanSupplyForSubcontractSuratJalanNo : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			orderQty : '0',
			deliveryQty : '0',
			workOrderSupplySubcontractDetailId : '0',
			workOrderSupplySubcontractDetailPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}